import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { LocationPickerModeEnum } from './location-picker.enum'
import { SearchBarPicker } from '../../atoms'
import { SearchBarPickerModeEnum } from '../../atoms/fields/search-bar-picker/search-bar-picker.enum'
import Icon from '../../atoms/icons/icon'
import { cn } from '../../../shadcn/utils'

type LocationSearchBarPickerProps = {
  value?: React.ReactNode
  mode: LocationPickerModeEnum
  isMobile: boolean
  alternativeClassName?: string
  isLocationSelected: boolean
  revampPicker: boolean
}

const MapPointerIcon: React.FC<{ isLocationSelected: boolean }> = ({
  isLocationSelected,
}) => (
  <div className={cn(isLocationSelected ? 'text-black' : 'text-grey-600')}>
    <Icon name='map-pointer' size={20} />
  </div>
)

const getPlaceholder = (mode: LocationPickerModeEnum) => {
  if (mode !== LocationPickerModeEnum.HOUSE_SEARCH) {
    return (
      <FormattedMessage
        id='ui.LocationPicker.cityDepartmentRegion'
        defaultMessage='Ville, département, région...'
      />
    )
  }
  return (
    <FormattedMessage
      id='ui.LocationPicker.placeholder.where'
      defaultMessage='Où allez-vous ?'
    />
  )
}

const getLabel = (mode: LocationPickerModeEnum) => {
  if (mode === LocationPickerModeEnum.HOUSE_SEARCH) {
    return null
  }
  return (
    <FormattedMessage
      id='ui.LocationPicker.destination'
      defaultMessage='Destination'
    />
  )
}

export const LocationSearchBarPicker: React.FC<
  React.PropsWithChildren<LocationSearchBarPickerProps>
> = ({ mode, isLocationSelected, children, revampPicker, ...props }) => {
  const isHouseSearchMode = mode === LocationPickerModeEnum.HOUSE_SEARCH
  return (
    <>
      {isHouseSearchMode && (
        <>
          {props?.value && revampPicker ? null : (
            <MapPointerIcon isLocationSelected={isLocationSelected} />
          )}
        </>
      )}
      {children}
      <SearchBarPicker
        placeholder={getPlaceholder(mode)}
        label={getLabel(mode)}
        mode={
          isHouseSearchMode ? SearchBarPickerModeEnum.HOUSE_SEARCH : undefined
        }
        className={s.searchBarPickerClassName}
        {...props}
      />
    </>
  )
}
